import 'bootstrap/dist/css/bootstrap.css';
import './reactstrapFixes';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

// Ensure no service worker or Cache API entries are used.
if (typeof window !== 'undefined') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch(() => {});
  }

  if ('caches' in window) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      .catch(() => {});
  }
}

// Detect interpreter portal impersonation (?impersonate=<base64-encoded user info>)
// Storing in sessionStorage keeps it tab-isolated so the admin's own session is unaffected.
try {
  const url = new URL(window.location.href);
  const impersonateEncoded = url.searchParams.get('impersonate');
  if (impersonateEncoded) {
    const userInfo = JSON.parse(atob(impersonateEncoded));
    sessionStorage.setItem('user', JSON.stringify(userInfo));
    sessionStorage.setItem('isImpersonation', 'true');
    document.body.classList.add('impersonation-mode');
    url.searchParams.delete('impersonate');
    window.history.replaceState({}, document.title, url.pathname + url.search);
  } else if (sessionStorage.getItem('isImpersonation') === 'true') {
    document.body.classList.add('impersonation-mode');
  }
} catch (e) {}

const root = createRoot(rootElement);

root.render(
  <ErrorBoundary>
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);
